





























































































import { AwsService as awsApi } from "@/common/api";
import { LANG } from "@/common/constant";
import {
  formatFileUrl,
  formatImageUrl,
  formatVideoUrl,
  isImageMime,
} from "@/common/utils";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MagazinesDetailComponent",
  components: {},
})
export default class MagazinesDetailComponent extends Vue {
  public isShow = false;
  public isHasEnLang = true;
  public isHasCnLang = true;
  public mailMagazine: any = {};
  public currentLang = LANG.JA;
  public contextFooter =
    "<br><br><br>\n" +
    "                  =======================================<br>\n" +
    "                  成田養魚園株式会社<br>\n" +
    "                  〒485-0075 愛知県小牧市三ツ渕815番地<br>\n" +
    "                  TEL：0568-77-8998 / FAX：0568-77-8997<br>\n" +
    "                  MAIL：info@narita-koi.com<br>\n" +
    "                  営業時間：水曜・木曜・金曜 13:00〜17:00 土曜・日曜 10:00〜17:00（平日は来園予約が必要です）<br>\n" +
    "                  定休日：月・火曜日<br>\n" +
    "                  =======================================";

  public show(mailMagazine) {
    this.currentLang = LANG.JA;
    this.mailMagazine = mailMagazine;
    if (!this.mailMagazine.title_en || !this.mailMagazine.context_en) {
      this.isHasEnLang = false;
    }
    if (!this.mailMagazine.title_cn || !this.mailMagazine.context_cn) {
      this.isHasCnLang = false;
    }
    this.isShow = true;
  }

  public closePopup() {
    this.isShow = false;
  }

  public formatFileUrl(fileName, extension) {
    if (["mp4", "mov"].includes(extension)) {
      return formatVideoUrl(fileName);
    } else if (["jpeg", "jpg", "png", "gif", "svg"].includes(extension)) {
      return formatImageUrl(fileName);
    } else {
      return formatFileUrl(fileName);
    }
  }

  public async viewFile(file) {
    let url = formatImageUrl(file.name);
    if (!isImageMime(file.mimeType)) {
      const { data } = await awsApi.awsDownloadFilePresign({
        filePath: file.name,
      });
      url = data.presign.url;
    }
    window.open(url, "_blank");
  }
}
